import { Box, Typography, useTheme, CircularProgress } from "@mui/material";
import { format, parseISO } from "date-fns";
import InfoCell from "../../../../common/components/ui-kit/info-cell";
import { useGetContractByPropertyUid } from "../../../hooks/contract/contract.hook";

export default function PropertyContractStartDate({
  propertyUId,
}: {
  propertyUId: string;
}) {
  const theme = useTheme();
  const {
    data: contract,
    isLoading,
    isError,
  } = useGetContractByPropertyUid(propertyUId);

  const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) return "N/A";
    try {
      const date = parseISO(dateString);
      return format(date, "MMM d, yyyy");
    } catch {
      return "N/A";
    }
  };

  const renderContent = () => {
    if (isLoading) {
      return <CircularProgress size={20} />;
    }

    if (isError) {
      return (
        <Typography
          sx={theme.nawy.typography.english.variants.body.sm.regular}
          color="error"
        >
          Failed to load contract data
        </Typography>
      );
    }

    if (contract) {
      return (
        <InfoCell
          title="Start Date"
          description={formatDate(contract.startDate)}
        />
      );
    }

    return (
      <Typography sx={theme.nawy.typography.english.variants.body.sm.regular}>
        No contract found
      </Typography>
    );
  };

  return (
    <Box
      sx={{
        borderRadius: "12px",
        backgroundColor: "#FFFFFF",
        width: "100%",
        padding: "16px",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography
              sx={theme.nawy.typography.english.variants.body.md.semibold}
            >
              Contract Start Date
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: "40px",
              justifyContent: "start",
            }}
          >
            {renderContent()}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
